import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Link, PageHeading, PromiseMessage, PromiseRetry, routerStore } from 'lib/components';
import { pagedListResponseUtils } from '../../domain';
import { dateFormat, msToHumanTime, ReactNodeGenerator } from 'lib/helpers';
import { routes } from 'pages/Routes';
import { StudentHomeworkListStore } from './StudentHomeworkListStore';
import { Homework } from 'scenes/homework/homework-models';
import { Helmet, HelmetTags } from "react-helmet";
import { EssayStatus } from 'domain/enums';
import Swal from 'sweetalert2';
import { HomeworkSelect } from 'lib/components/select/HomeworkStatusSelect';
import { border } from '@mui/system';
import { lightBlue } from '@mui/material/colors';
import { withTranslation, WithTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

interface IProps extends WithTranslation {
  
}


@observer
class StudentHomeworkListScene extends React.Component<IProps> {
  store: StudentHomeworkListStore;
  t: TFunction;

  constructor(props: any) {
    super(props);
    this.store = new StudentHomeworkListStore();
    this.t = props.t;
  }

  componentDidMount() {
    this.store.load();
  }

  render() {
    return Array.from(this.renderer(this.store, this.t));
  }


  * renderRows(store: StudentHomeworkListStore, t: any): ReactNodeGenerator {
    if (store.homeworkState?.isResolved !== true)
      return;

    const homeworks = store.homeworkState.response.data.Data;
    if (homeworks != null) {
      for (let homework of homeworks) {
        yield (
          <tr key={homework.Id}>
            <td>
              {homeworks.indexOf(homework) + 1}
            </td>
            <td>
              {homework.TeacherName}
            </td>
            <td>
              {homework.Description}
            </td>
            <td>
              {dateFormat(homework.CreatedAt, 'wymdhm', true)}
            </td>
            <td>
              {homework.Status}
            </td>
            <td>
              <button type='button' className="btn btn-primary" onClick={(e) => this.onHomeworkOpenBtnClick(e, homework)}>
                {t("button.open")}
              </button>
            </td>
          </tr>
        );
      }
    }
  }

  * renderer(store: StudentHomeworkListStore, t: any): ReactNodeGenerator {
    if (store.homeworkState == null)
      return;
    const state = store.homeworkState;

    yield (<PromiseMessage key="loader-state"
      label={t('homework.loading')} state={state} align="right" />);

    yield (<PromiseRetry key="retry-actions"
      state={state} retry={store.load} align="right" />);

    if (!state.isResolved)
      return;

    const response = store.homeworkState.value;
    const U = pagedListResponseUtils;

    if (response != null) {
      yield (
        <div className="row" key="response-count">
          <div className="col-sm-12 col-md-6">
            <div className="row" key="add-form">
              <div className="col-auto ml-6">
                <button type="button" className={store.filterDate == "Day" ? "btn btn-primary" : "btn btn-outline-primary"}
                  onClick={store.getDay} value="test">{t('filter.day')}
                </button>

                <button type="button" className={store.filterDate == "Week" ? "btn btn-primary" : "btn btn-outline-primary"}
                  onClick={store.getWeek} value="test" >{t('filter.week')}
                </button>

                <button type="button" className={store.filterDate == "Month" ? "btn btn-primary" : "btn btn-outline-primary"}
                  onClick={store.getWeek} value="test" >{t('filter.month')}
                </button>

                <button type="button" className={store.filterDate == "Year" ? "btn btn-primary" : "btn btn-outline-primary"}
                  onClick={store.getWeek} value="test" >{t('filter.year')}
                </button>
              </div>
              <div className="md-col-sm-12 col-md-5">
                <HomeworkSelect value={store.status.value}
                  onChange={store.status.setValue} />
              </div>
            </div>
          </div>

          <div className="col-auto ml-auto">
            {t('filter.total', { total: response.CountRecords, currentPage: response.CurrentPage + 1, pages: Math.ceil(response.CountRecords / 8) })}
            <button type="button" className="btn btn-primary"
              disabled={!U.hasPreviousPage(response)}
              onClick={store.loadPreviousPage}>
              <span className="fas fa-angle-left" /> {t('filter.prev')}
            </button>
            <button type="button" className="btn btn-primary"
              onClick={store.load}>
              <span className="fas fa-sync" /> {t('filter.refresh')}
            </button>
            <button type="button" className="btn btn-primary"
              onClick={store.resetResults}>
              <span className="fas fa-sync" /> {t('filter.reset')}
            </button>
            <button type="button" className="btn btn-primary"
              disabled={!U.hasNextPage(response)}
              onClick={store.loadNextPage}>
              {t('filter.next')}
              <span className="fas fa-angle-right pl-1" />
            </button>
          </div>
        </div>);
    }
    const homeworks = state.value.Data;

    if (homeworks != null && homeworks.length === 0) {
      yield (
        <div className="row justify-content-center" key="no-classrooms">
          <div className="col-auto">
            <div className="alert alert-info">{t('homework.no-homework')}</div>
          </div>
        </div>
      );
      return;
    }
    yield (
      <div className="row" key="schedule">
        <div className="col">
          <table className="table table-sm table-bordered table-hover">
            <thead>
              <tr>
                <th>{t('homework.table.number')} </th>
                <th>{t('homework.table.teacher')} </th>
                <th>{t('homework.table.description')} </th>
                <th>{t('homework.table.create-date')} </th>
                <th>{t('homework.table.status')} </th>
                <th>{t('homework.table.action')} </th>
              </tr>
            </thead>
            <tbody>
              {Array.from(this.renderRows(store, t))}
            </tbody>
          </table>
        </div>
      </div>);
  }

  componentWillUnmount() {
    this.store.dispose();
  }

  onHomeworkOpenBtnClick = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, homework: Homework) => {
    let link: string;
    link = routes.StudentHomeworkLink(homework.LessonHomeworkId);
    routerStore.navigateTo(link);
  }
}

export default withTranslation()(StudentHomeworkListScene);